import { render } from "./FormIntentionsView.vue?vue&type=template&id=4461618c"
import script from "./FormIntentionsView.vue?vue&type=script&lang=js"
export * from "./FormIntentionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__